import {rootReducer} from "./rootReducer"
import {configureStore} from "scholastic-client-components/src/SharedPackages/reduxToolkit"
import {getStoreWatchers} from "scholastic-client-components/src/middlewares/reduxMiddlewares"

export const store = configureStore({
    reducer: rootReducer,
    middleware: [...getStoreWatchers()],
})
